<template>
  <div
    v-if="isLoading"
    class="tableLoading"
  >
    <div class="spinner">
      <div class="bounce1" />
      <div class="bounce2" />
      <div class="bounce3" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false
    }
  }

}
</script>

<style lang="sass">
  .tableLoading
    margin: 25px 0px 0px 0px
    font-size: 20px
    +LoadingEffect
    justify-self: center
    align-self: center
</style>
